export enum SessionAssignTo {
  All = 'ALL',
  Specific = 'SPECIFIC',
}
